<template>
  <v-navigation-drawer
    absolute
    permanent
    right
    color="#173862"
    width="25%"
  >
    <template v-slot:prepend>
      <LoginTrialCard v-if="!$vuetify.breakpoint.mobile"/>
    </template>
  </v-navigation-drawer>
</template>

<script>
  export default {
    components: { 
      LoginTrialCard: () => import('@/components/LoginTrialCard')
    }
  }
</script>

<style lang="scss" scoped>

</style>